import React, { useEffect, useState } from "react";
import { legislationsAPI } from "../../../services/api";
import StatsBoxes from "../../community/cards/StatsCard";
import { useFetch } from "../../../hooks/useCallApi";

const Statistics = () => {
  const [counts, setCounts] = useState({
    total_resolutions: 0,
    total_ordinances: 0,
    total_active_consultations: 0,
  });

  const statConfigs = [
    {
      key: "total_resolutions",
      title: "Total Resolutions",
      subtitle: "Number of Created Resolutions",
      bgColor: "#DBEAFE",
      textColor: "#2563EB",
    },
    {
      key: "total_ordinances",
      title: "Total Ordinances",
      subtitle: "Total Enacted and Proposed Ordinances",
      bgColor: "#FFEDD5",
      textColor: "#C2410C",
    },
    {
      key: "total_active_consultations",
      title: "Active Consultations",
      subtitle: "Number of Active and Scheduled Consultations",
      bgColor: "#D1FAE5",
      textColor: "#16A34A",
    },
  ];


  // const { data } = useFetch(
  //   ['legislation'],
  //   (api) => api.legislation.dasboard()
  // )

  // console.log("data", data)

  useEffect(() => {
    const loadDashboard = async () => {
      try {
        const res = await legislationsAPI.getDashboard();
        const data = res.data.data.legislations;

        setCounts({
          total_resolutions: data.total_resolutions ?? 0,
          total_ordinances: data.total_ordinances ?? 0,
          total_active_consultations: data.total_active_consultations ?? 0,
        });
      } catch (error) {
        console.error("Dashboard Error:", error);
      }
    };

    loadDashboard();
  }, []);

  return <StatsBoxes counts={counts} statConfigs={statConfigs} />;
};

export default Statistics;
